import { InMemoryCache, makeVar } from '@apollo/client';

// Initializes to true if localStorage includes a 'token' key,
// false otherwise
export const isLoggedInVar = makeVar(!!localStorage.getItem('prospero-token'));
export const userVar = makeVar(null);
export const fromAppVar = makeVar(null);
export const appSessionTokenVar = makeVar(null);
export const mondayBoardIdVar = makeVar(null);
export const userProfileVar = makeVar(null);
export const proposalsVar = makeVar([]);
export const proposalsStatsVar = makeVar({ approvedCount: 0, acceptanceRate: 0 });
export const proposalsImportVar = makeVar([]);
export const proposalsClientVar = makeVar([]);
export const teamMembersVar = makeVar([]);
export const adminVar = makeVar(null);
export const adminProfileVar = makeVar(null);
export const fontLoadedVar = makeVar(false);
export const templatesVar = makeVar([]);
export const sectionsVar = makeVar([]);
export const featureFlagsVar = makeVar(null);
export const catalogsCountVar = makeVar(0);
export const scheduleSuccessModalVar = makeVar(false);
export const hubspotUrlParams = makeVar({});

export const cache = new InMemoryCache({
  addTypename: false,
  typePolicies: {
    Query: {
      fields: {
        isLoggedIn: {
          read() {
            return isLoggedInVar();
          },
        },
        user: {
          read() {
            return userVar();
          },
        },
        fetchUser: {
          keyArgs: ['_id'],
          merge(existing = {}, incoming) {
            let data = {};
            if (incoming) {
              data = { ...existing, ...incoming };
            } else {
              data = existing;
            }
            return data;
          },
        },
        userProfile: {
          read() {
            return userProfileVar();
          },
        },
        proposals: {
          read() {
            return proposalsVar([]);
          },
        },
        fetchActivities: {
          keyFields: ['_id'],
        },
      },
    },
  },
});

export const getUserId = () =>
  (adminVar() && window.localStorage.getItem('proxy-user-id')) ||
  window.localStorage.getItem('prospero-user-id');
